module.exports = __webpack_public_path__ + "static/img/logo6.f25f3ca3.png";